// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styles } from "@bg/App/Widgets/MyCustomQuoteDetails/MyCustomQuoeDetailsOptions";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.addItems = {
    css: css`
        padding: 0 10px;

        &&&& ${IconWrapper} {
            left: -2px;
            top: 2px;
        }
        && svg {
            transition: all 200ms ease-in-out;
            color: ${getColor("text")};
        }
    `,
    icon: {
        src: "AddToList",
        position: "left",
    },
};

styles.calculateMarginButton = {
    css: css`
        padding: 0 10px;
        &&&& ${IconWrapper} {
            width: 18px;
            top: 5px;
            left: -3px;
        }
        && svg {
            transition: all 200ms ease-in-out;
            height: 18px;
            width: 18px;
            color: ${getColor("text")};
        }
    `,
    icon: {
        src: "Calculator",
        position: "left",
    },
};

styles.printAllCodes = {
    typographyProps: {
        lineHeight: "20px",
    },
    css: css`
        margin-left: 30px;
        padding: 0 10px;
        &&&& ${IconWrapper} {
            height: 18px;
            width: 18px;
            top: 3px;
            left: -4px;
        }
        && svg {
            transition: all 200ms ease-in-out;
            height: 18px;
            width: 18px;
            color: ${getColor("text")};
        }
    `,
    icon: {
        src: "QrCode",
        position: "left",
    },
};

styles.productSelectorStyles = {
    ...styles.productSelectorStyles,
    searchDynamicDropdown: {
        cssOverrides: {
            ...styles.productSelectorStyles?.searchDynamicDropdown?.cssOverrides,
            formInputWrapper: css`
                margin-top: 0 !important;
                && input + span {
                    font-size: ${fontConfig.fontSize.small}px;
                    line-height: unset;
                }
            `,
        },
        iconProps: {
            css: css`
                &&& {
                    max-width: 23px;
                    max-height: 100%;
                    top: 0;
                }
            `,
        },
        list: css`
            top: 32px;
            width: 100%;
            border-top: 0;
        `,
    },
    qtyWrapper: {
        css: css`
            display: flex;
            align-items: center;
            width: 160px;
            padding: 0;
            margin-right: 30px;

            &&& > label {
                width: auto;
                font-weight: ${fontConfig.weight.bold};
                font-size: ${fontConfig.fontSize.small}px;
                margin-right: 8px;
                white-space: nowrap;
            }

            label + div {
                margin-top: 0;
                height: 32px;
            }

            &&& input {
                height: 28px !important;
            }
        `,
    },
} as any;
